import React from "react";
import { motion } from "framer-motion";

const Float = () => {
  return (
    <div>
      <h4>Float</h4>
      <div
        style={{
          height: "200px",
          width: "25vw",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
        className="center"
      >
        <motion.div
          className="box"
          style={{ backgroundColor: "#845EC2" }}
          animate={{ y: [0, -40, 0] }}
          transition={{
            duration: 1.8,
            loop: Infinity, 
            ease: ["linear", "linear"],
          }}
        ></motion.div>
        <motion.div
          className="box"
          style={{ backgroundColor: "#3596B5" }}
          animate={{ y: [-50, 0, -50] }}
          transition={{
            duration: 2,
            loop: Infinity,
            ease: ["linear", "linear"],
          }}
        ></motion.div>
        <motion.div
          className="box"
          style={{ backgroundColor: "#296073" }}
          animate={{ y: [0, -50, 0] }}
          transition={{
            duration: 2,
            loop: Infinity,
            ease: ["linear", "linear"],
          }}
        ></motion.div>
      </div>
    </div>
  );
};
export default Float;
